import { render, staticRenderFns } from "./ChemUCI51LCPL3Q3.vue?vue&type=template&id=1617fcfb&scoped=true&"
import script from "./ChemUCI51LCPL3Q3.vue?vue&type=script&lang=js&"
export * from "./ChemUCI51LCPL3Q3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1617fcfb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VForm,VImg,VRadio,VRadioGroup})
